module.exports = __webpack_public_path__ + "img/answer_right.9338aae9.png";